import { useEffect, useState } from 'react';

const useHeadingsData = (content) => {
  const [ headings, setHeadings ] = useState([]);

  useEffect(() => {
    let mounted = true;

    if (content) {
      const headingElements =
        Array
          .from(document.querySelectorAll('h1[id], h2[id], h3[id], h4[id]'))
          .map(el => {
            return {
              id: el.id,
              text: el.innerText,
              level: Number(el.nodeName.charAt(1)) - 1
            };
          });
      
      mounted && setHeadings(headingElements);
    }

    return () => {
      mounted = false;
    }
  }, [ content ]);

  return { headings };
}

export default useHeadingsData;